import React, { useEffect, useState } from "react";
import DataTable from "../../../../Components/Others/DataTable";
import ViewToggle from "../../../../Components/Utils/ViewToggle";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  ImportButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "../../../../Components/Utils/SearchBar";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import CustomDataTable from "../../../../Components/Others/CustomDataTable";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import { useFormik } from "formik";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { NuDate } from "../../../../Components/Utils/Input";
import NuAmount from "../../../../Components/Utils/NuAmount";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import * as yup from "yup";

import ModalContainer from "../../../../Components/Others/ModalContainer";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import { GetAccess, GetRole, CheckEditAction, CheckDeleteAction } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import UseFetchCurrency from "../../../../Components/Hooks/useFetchCurrencyData";
import PremiumTable, { CopyButton } from "../../../../Components/Others/PremiumTable";
import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
import moment from "moment";

// Icons for Approval Status
const HourglassIcon = () => (
  <svg className="w-4 h-4 text-amber-500 animate-pulse shrink-0" viewBox="0 0 384 512" fill="currentColor" title="Pending">
    <path d="M360 0H24C10.7 0 0 10.7 0 24v16c0 13.3 10.7 24 24 24h16v96c0 56.6 32.7 105.6 80 128-47.3 22.4-80 71.4-80 128v96H24c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24h-16v-96c0-56.6-32.7-105.6-80-128 47.3-22.4 80-71.4 80-128V64h16c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24zm-80 448H104v-48c0-44.1 35.9-80 80-80s80 35.9 80 80v48zm0-240v16H104v-16c0-44.1 35.9-80 80-80s80 35.9 80 80z" />
  </svg>
);

const ApprovedIcon = () => (
  <svg className="w-4 h-4 text-emerald-500 shrink-0" viewBox="0 0 512 512" fill="currentColor" title="Approved">
    <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm108.384 186.758l-140.2 140.2c-4.7 4.7-12.3 4.7-17 0l-71.8-71.8c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l46.3 46.3 114.7-114.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17z" />
  </svg>
);

const RejectedIcon = () => (
  <svg className="w-4 h-4 text-rose-500 shrink-0" viewBox="0 0 512 512" fill="currentColor" title="Rejected">
    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.6 65-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65z" />
  </svg>
);

// const renderApprovalStatusIcon = (status) => {
//   if (status === "Approved" || status === "Completed") return <ApprovedIcon />;
//   if (status === "Rejected") return <RejectedIcon />;
//   return <HourglassIcon />;
// };

const renderApprovalStatusIcon = (status) => {
  const value = status?.trim().toLowerCase();

  if (value === "approved" || value === "completed") {
    return <ApprovedIcon />;
  }

  if (value === "rejected") {
    return <RejectedIcon />;
  }

  return <HourglassIcon />;
};
// Payment Request Table Row Component
const PaymentRequestTableRow = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const formattedDate = row.date ? moment(row.date).format("DD-MMM-YYYY") : "--";
  return (
    <tr className="bg-white hover:bg-white/80 transition-colors align-middle">
      {/* Checkbox */}
      <td className="p-4 text-center align-middle border-t border-b border-l border-gray-200/60 rounded-tl-xl rounded-bl-xl">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onSelect}
          className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
        />
      </td>

      {/* YPR */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
        <div className="flex items-center gap-1.5">
          <span className="text-sm font-bold text-gray-800">
            {row.prRef || "N/A"}
          </span>
          <CopyButton text={row.prRef} />
        </div>
      </td>

      {/* PO No. */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
        <div className="flex items-center gap-1.5">
          <Link
            to={`/procurement/payment-request/view/${row.id}`}
            state={{
              data: row,
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }}
            className="hover:underline text-sm font-bold text-gray-800"
          >
            {row.poRef || "N/A"}
          </Link>
          <CopyButton text={row.poRef} />
        </div>
      </td>

      {/* Invoice In. */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600">
        {row.invoiceRef || "N/A"}
      </td>

      {/* Currency */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
        {row.currency || "SAR"}
      </td>

      {/* Invoice Amount */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-bold text-gray-800">
        <NuAmount currency={row["vendorCurrency"] || row["currency"]} value={row.invoiceAmount || 0} />
      </td>

      {/* Status */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 whitespace-nowrap">
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${row.status === "Approved" || row.status === "Completed"
          ? "bg-emerald-50 text-emerald-700 border-emerald-100"
          : row.status === "Pending" || row.status === "new"
            ? "bg-amber-50 text-amber-700 border-amber-100"
            : "bg-gray-50 text-gray-600 border-gray-100"
          }`}>
          {row.status || "N/A"}
        </span>
      </td>

      {/* Action Buttons */}
      <td className="p-4 text-center align-middle border-t border-b border-r border-gray-200/60 rounded-tr-xl rounded-br-xl">
        <div className="flex items-center justify-center gap-1.5">
          {/* Approval Status Icon */}
          {renderApprovalStatusIcon(row.approvalStatus)}

          {/* View */}
          <Link
            to={`/procurement/payment-request/view/${row.id}`}
            state={{
              data: row,
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }}
            className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
            title="View details"
          >
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          </Link>
          {/* Edit */}
          {CheckEditAction(row, "Payment Request", canEdit) && (
            <Link
              to={`/procurement/payment-request/edit/${row.id}`}
              state={{
                data: row,
                from: "/procurement/payment-request",
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="Edit Payment Request"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </Link>
          )}
          {/* Delete */}
          {CheckDeleteAction(row, canDelete) && (
            <button
              onClick={() => handleDelete("/payment-request/", row.id, row.poRef || row.ref, "Payment Request")}
              className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="Delete Payment Request"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          )}
        </div>
      </td>
    </tr>
  );
};

// Payment Request Card Component
const PaymentRequestCard = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const formattedDate = row.date ? moment(row.date).format("DD-MMM-YYYY") : "--";
  return (
    <div className="relative border border-y-gray-200/50 border-r-gray-200/50 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-4 flex flex-col gap-4 overflow-hidden border-l-4 border-l-indigo-500">
      {/* Card Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start gap-4">
        <div className="flex items-center gap-2.5">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
          />
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5">
              <Link
                to={`/procurement/payment-request/view/${row.id}`}
                state={{
                  data: row,
                  pageIndex: pageIndex,
                  searchQuery: searchQuery,
                }}
                className="text-gray-800 font-bold hover:underline text-sm"
              >
                {row.poRef || row.ref || "N/A"}
              </Link>
              <CopyButton text={row.poRef || row.ref} />
            </div>
            <div className="flex items-center gap-1 mt-0.5">
              <span className="text-[10px] text-gray-500 font-bold">YPR: {row.prRef || "N/A"}</span>
              <CopyButton text={row.prRef} />
            </div>
            <span className="text-[10px] text-gray-400 font-bold mt-0.5">Supplier: {row.vendorName || "N/A"}</span>
          </div>
        </div>

        {/* Status Badge & Approval Icon */}
        <div className="flex items-center gap-2">
          {renderApprovalStatusIcon(row.approvalStatus)}
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${row.status === "Approved" || row.status === "Completed"
            ? "bg-emerald-50 text-emerald-700 border-emerald-100"
            : row.status === "Pending" || row.status === "new"
              ? "bg-amber-50 text-amber-700 border-amber-100"
              : "bg-gray-50 text-gray-600 border-gray-100"
            }`}>
            {row.status || "N/A"}
          </span>
        </div>
      </div>

      {/* Middle Grid */}
      <div className="bg-[#FAFAFC]/60 rounded-xl p-3.5 border border-gray-100 flex flex-col gap-2 text-xs">
        {/* Invoice Ref row */}
        <div className="flex justify-between items-center">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Invoice Ref.</span>
          <div className="flex items-center gap-1">
            <span className="font-bold text-gray-700">{row.invoiceRef || "N/A"}</span>
            {row.invoiceRef && <CopyButton text={row.invoiceRef} />}
          </div>
        </div>
        {/* Currency + Invoice Amount */}
        <div className="flex justify-between items-center">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Currency</span>
          <span className="font-bold text-gray-700">{row.currency || "SAR"}</span>
        </div>
        <div className="flex justify-between items-center border-t border-gray-100 pt-1.5 mt-0.5">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Invoice Amount</span>
          <span className="font-extrabold text-gray-800">
            <NuAmount currency={row["vendorCurrency"] || row["currency"]} value={row.invoiceAmount || 0} />
          </span>
        </div>
      </div>

      {/* Action Buttons Row */}
      <div className="flex flex-wrap sm:flex-nowrap items-center justify-between gap-2 border-t border-gray-100 pt-3 mt-1">
        <Link
          to={`/procurement/payment-request/view/${row.id}`}
          state={{
            data: row,
            pageIndex: pageIndex,
            searchQuery: searchQuery,
          }}

          className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-3 py-1.5 rounded-lg transition-all duration-200 flex items-center justify-center gap-1.5 text-xs font-semibold flex-1 sm:flex-none"
        >
          <svg className="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          <span className="whitespace-nowrap">View Details</span>
        </Link>
        <div className="flex gap-2 flex-1 sm:flex-none justify-end">
          {CheckEditAction(row, "Payment Request", canEdit) && (
            <Link
              to={`/procurement/payment-request/edit/${row.id}`}
              state={{
                data: row,
                from: "/procurement/payment-request",
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-3 py-1.5 rounded-lg transition-all duration-200 flex items-center justify-center gap-1.5 text-xs font-semibold flex-1 sm:flex-none"
            >
              <svg className="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              <span className="whitespace-nowrap">Edit</span>
            </Link>
          )}
          {CheckDeleteAction(row, canDelete) && (
            <button
              onClick={() => handleDelete("/payment-request/", row.id, row.poRef || row.ref, "Payment Request")}
              className="border border-red-100 text-red-500 hover:bg-red-50 px-3 py-1.5 rounded-lg transition-all duration-200 flex items-center justify-center gap-1.5 text-xs font-semibold flex-1 sm:flex-none cursor-pointer"

            >
              <svg className="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              <span className="whitespace-nowrap">Delete</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

function PaymentRequestIndex() {
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20,
  );

  const state = location.state;

  const [filter, setFilter] = useState(
    state?.approvalStatus || state?.category ? true : false,
  );
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [viewMode, setViewMode] = useState(localStorage.getItem("paymentRequestViewMode") || "table");
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobileScreen ? "card" : viewMode;

  const { value: status } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_invoicesIncoming",
    showFilterDialog,
  );
  const { value: priorityRFQ } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "priority_RFQ",
    showFilterDialog,
  );
  let { value: currency } = UseFetchCurrency("/currency/drop-down");
  const { value: ModeOfPayment, getData: refModeOfPayment } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "ModeOfPayment_invoicesIncoming",
    showFilterDialog,
  );

  const [filterProps, setFilterProps] = useState({
    modeOfPayment: "",
    status: "",

    currency: "",
    priority: "",
    approvalStatus: "",
    dateFrom: "",
    dateTo: "",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    modeOfPayment: "",
    status: "",

    currency: "",
    priority: "",
    approvalStatus: "",
    dateFrom: "",
    dateTo: "",
  });

  useEffect(() => {
    if (searchQuery) {
      setParams({ ...params, search: searchQuery });
    }
  }, [searchQuery]);

  const clearFilter = () => {
    setParams({
      ...params,
      modeOfPayment: "",
      status: "",
      currency: "",
      priority: "",
      approvalStatus: "",
      dateFrom: "",
      dateTo: "",
    });
    formik.values.status = "";
    formik.values.modeOfPayment = "";
    formik.values.dateTo = "";
    formik.values.dateFrom = "";
    formik.values.priority = "";
    formik.values.approvalStatus = "";
    formik.values.currency = "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      setParams({
        ...params,
        status: value.status,
        modeOfPayment: value.modeOfPayment,
        currency: value.currency,
        priority: value.priority,
        dateFrom: value.dateFrom,
        approvalStatus: value.approvalStatus,
        dateTo: value.dateTo,
      });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        modeOfPayment: "",
        status: "",
        currency: "",
        priority: "",
        approvalStatus: "",
        dateFrom: "",
        dateTo: "",
      });
    },
  });
  const { data, totalCount, getData, dataLoading } = UseGetDataSearch(
    "/payment-request/",
    params,
  );

  const defaultHeader = [
    {
      title: "YPR",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/procurement/payment-request/view/",
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "PO No.",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/procurement/payment-request/view/",
      field: "poRef",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Invoice In.",
      width: "10%",
      field: "invoiceRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Currency",
      width: "10%",
      field: "currency",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Invoice Amount",
      width: "10%",
      type: "amount",
      field: "invoiceAmount",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "id",
        removeValue: "ref",
        url: `/payment-request/`,
        moduleName: "Payment Request",
        from: `/procurement/payment-request`,
        editLink: "/procurement/payment-request/edit/",
        viewLink: "/procurement/payment-request/view/",
      },
    },
  ];
  const availableHeaders = [
    // {
    //   title: "ID",
    //   width: "5%",
    //   field: "id",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "YPR",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/procurement/payment-request/view/",

      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "PO No.",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/procurement/payment-request/view/",
      field: "poRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Invoice In.",
      width: "10%",
      field: "invoiceRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Currency",
      width: "10%",
      field: "currency",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Invoice Amount",
      width: "10%",
      type: "amount",
      field: "invoiceAmount",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Bank Charges",
      width: "10%",
      type: "amount",
      field: "bankCharges",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Total Amount ",
      width: "10%",
      type: "amount",
      field: "totalAmount",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Mode of Pamt.",
      width: "10%",
      field: "modeOfPayment",
      textAlign: "center",
      rowAlign: "center",
    },

    // {
    //   title: "Paid Amount",
    //   width: "5%",
    //   field: "paidAmount",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Paid On",
      width: "5%",
      field: "paidOn",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Priority",
      width: "5%",
      field: "priority",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "id",
        removeValue: "ref",
        url: `/payment-request/`,
        moduleName: "Payment Request",
        from: `/procurement/payment-request`,
        editLink: "/procurement/payment-request/edit/",
        viewLink: "/procurement/payment-request/view/",
      },
    },
  ];
  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

  // hasMultiEdit=true,
  // selectMultipleFunction=()=>{},
  // selectOneFunction=()=>{},
  // listofNumbers=[1,2],
  // setShowEdit=()=>{},
  // showEdit=false,
  // setShowDelete=()=>{},
  // showDelete=false,

  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
  };

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      setListofNumbers(fullList);
    } else {
      setListofNumbers([]);
    }
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        tempArr.push(i?.id);
      });
    setFullList(tempArr);
  }, [data]);

  const canEdit = GetAccess("payment_request_edit") || GetRole();
  const canDelete = GetAccess("payment_request_delete") || GetRole();
  const { handle: handleDelete } = useDeleteData(getData);

  return (
    <div className="w-full h-full px-2 sm:px-4 py-2">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[{ name: "Procurement" }, { name: "Payment Request" }]}
          />
          <div className="flex md:hidden items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
            {GetAccess("payment_request_create") && (
              <Link to="/procurement/payment-request/create">
                <CreateButton label="Payment Request" />
              </Link>
            )}
          </div>
        </div>

        <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2">
          <div className="w-full md:w-fit">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1);
              }}
              value={params.search}
            />
          </div>
          <div className="hidden md:flex items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
          </div>

          {/* Table / Card View Toggle */}
          <ViewToggle
            viewMode={effectiveViewMode}
            onViewChange={(mode) => setViewMode(mode)}
            storageKey="paymentRequestViewMode"
          />

          <div className="hidden md:flex items-center gap-2">
            {GetAccess("payment_request_create") && (
              <Link to="/procurement/payment-request/create">
                <CreateButton label="Payment Request" />
              </Link>
            )}
          </div>
        </div>
      </div>
      <PremiumTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        viewMode={effectiveViewMode}
        headers={[
          { title: "YPR", width: "160px" },
          { title: "PO No.", width: "160px" },
          { title: "Invoice In.", width: "150px" },
          { title: "Currency", width: "120px" },
          { title: "Invoice Amount", width: "150px" },
          { title: "Status", width: "120px" },
          { title: "Action", align: "center", width: "140px" }
        ]}
        renderRow={(row, idx) => (
          <PaymentRequestTableRow
            row={row}
            isSelected={listofNumbers.includes(row.id)}
            onSelect={() => selectOneFunction(row.id)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        renderCard={(row, idx) => (
          <PaymentRequestCard
            row={row}
            isSelected={listofNumbers.includes(row.id)}
            onSelect={() => selectOneFunction(row.id)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        dataLoading={dataLoading}
        listofNumbers={listofNumbers}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        multiEditLabel="Multi Edit"
      />
      {showFilterDialog && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-[92vw] sm:w-[520px] md:w-[620px] max-w-full max-h-[85vh] bg-white p-5 sm:p-6 rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
            <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
              <h2 className="text-lg font-bold text-gray-800">Filter Payment Request</h2>
              <button
                onClick={closeFilterDialog}
                type="button"
                className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <form onSubmit={formik.handleSubmit} className="flex flex-col gap-3">
              <div className="flex flex-col sm:flex-row flex-wrap -mx-2">
                <div className="w-full px-2 mb-2">
                  <p className="text-xs font-semibold text-gray-700 mb-1">Date Range</p>
                  <div className="flex gap-2">
                    <NuDate
                      label="From"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="dateFrom"
                      width="w-1/2"
                    />
                    <NuDate
                      label="To"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="dateTo"
                      width="w-1/2"
                    />
                  </div>
                </div>
                <FormikSelectTwo
                  Options={currency}
                  label="Currency"
                  placeholder="Currency"
                  formik={formik}
                  name="currency"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  label="Mode of Payment"
                  placeholder="Choose"
                  Options={ModeOfPayment}
                  formik={formik}
                  name="modeOfPayment"
                  width="w-full sm:w-1/2"
                  px="2"
                  getFunc={refModeOfPayment}
                  displayProperty={"Mode of Payment"}
                  propertyName={"ModeOfPayment_invoicesIncoming"}
                />
                <FormikSelectTwo
                  type="text"
                  label="Priority"
                  placeholder="Choose"
                  // disabled={true}
                  Options={priorityRFQ}
                  formik={formik}
                  name="priority"
                  width="w-full "
                />
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Status"
                  Options={status}
                  formik={formik}
                  name="status"
                  width="w-full"
                />
                <FormikSelectTwo
                  type="text"
                  label="Approval Status"
                  placeholder="Approval Status"
                  Options={[
                    {
                      value: "pending",
                      label: "pending",
                    },
                    {
                      value: "Verified",
                      label: "Verified",
                    },
                    {
                      value: "Approved",
                      label: "Approved",
                    },
                  ]}
                  formik={formik}
                  name="approvalStatus"
                  width="w-full "
                />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
      {/* {showImportModal && (<Importdoc show={showImportModal} onClose={closeModal} getData={getData} />)}
        {showEdit && (<MultiEditPr data={listofNumbers} getData={getData} onClose={()=>setShowEdit(false)}/>)} */}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => { }}
        closeModal={() => setShowDelete(false)}
      />
    </div>
  );
}

export default PaymentRequestIndex;
